/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/service/auth.service';
import { RoutingService } from 'src/app/service/routing.service';
import {
  AuditDataService,
  AuditData,
} from 'src/app/cockpit/main-news/news-audit-view/audit-data.service';
import { BreakpointService } from 'src/app/shared/services/breakpoints.service';

/** Query parameters that trigger audit data refresh */
const AUDIT_REFRESH_PARAMS = [
  'id',
  'type',
  'portfolioId',
  'time',
  'reflow',
  'update',
  'updateScores',
] as const;

@Component({
  selector: 'app-news-audit-view',
  templateUrl: './news-audit-view.component.html',
  styleUrls: ['./news-audit-view.component.scss'],
})
export class NewsAuditViewComponent implements OnDestroy {
  public params: any;
  private previousParams: any;
  private auditDataSubject = new BehaviorSubject<AuditData | null>(null);
  public auditData$ = this.auditDataSubject.asObservable();
  public loading$ = this.auditDataService.loading$;
  screenSize$ = this.breakpointService.screenSize$;

  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    public auth: AuthService,
    private auditDataService: AuditDataService,
    private breakpointService: BreakpointService,
    private routing: RoutingService,
  ) {
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        if (
          this.routing.reFresh(
            params,
            this.previousParams,
            AUDIT_REFRESH_PARAMS as unknown as string[],
          )
        ) {
          this.params = params;
          this.fetchAuditData(params);
        }
        this.previousParams = params;
      });
  }

  private fetchAuditData(params: any): void {
    const baseData: AuditData = {
      entity: { name: '', type: '' },
      sentiment: {},
    };
    this.auditDataService
      .getAuditData(params, baseData)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.auditDataSubject.next(data);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
